module.exports = __webpack_public_path__ + "static/media/team_strength.2d4ee997.svg";